<template>
     <v-theme-provider>
          <v-row justify="center">
               <v-expansion-panels accordion tile multiple>
                    <v-expansion-panel v-for="(item, i) in list" :key="i">
                         <v-expansion-panel-header
                              hide-actions
                              class="grey lighten-3 primary--text text-uppercase"
                         >
                              <template v-slot:default="{}">
                                   <v-row no-gutters>
                                        <v-col cols="12" class="text-center">
                                             {{ item.name }}
                                        </v-col>
                                   </v-row>
                              </template>
                         </v-expansion-panel-header>
                         <v-expansion-panel-content>
                              <v-row>
                                   <v-col
                                        cols="12"
                                        md="4"
                                        sm="4"
                                        class="ml-auto mr-auto"
                                        v-for="(subItem, j) in item.items"
                                        :key="j"
                                   >
                                        <v-list-item>
                                             <v-list-item-content>
                                                  <v-list-item-title
                                                       class="primary--text"
                                                       style="font-size: 1.5em"
                                                       >{{ subItem.name }}
                                                       <v-icon
                                                            v-if="subItem.spicy"
                                                            color="red darken-2"
                                                            >mdi-chili-mild</v-icon
                                                       >
                                                       <v-icon
                                                            v-if="
                                                                 subItem.glutonFree
                                                            "
                                                            style="
                                                                 margin-right: -15px;
                                                            "
                                                            >mdi-alpha-g</v-icon
                                                       >
                                                       <v-icon
                                                            v-if="
                                                                 subItem.glutonFree
                                                            "
                                                            style="
                                                                 padding-left: 0px;
                                                            "
                                                            >mdi-alpha-f</v-icon
                                                       >
                                                  </v-list-item-title>
                                                  <v-list-item-subtitle
                                                       style="font-size: 1em"
                                                       class="text-wrap"
                                                  >
                                                       {{
                                                            subItem.description
                                                       }}</v-list-item-subtitle
                                                  >
                                                  <v-list-item-subtitle
                                                       style="font-size: 1em"
                                                       class="text-wrap"
                                                       v-if="subItem.options"
                                                  >
                                                       {{
                                                            subItem.options
                                                       }}</v-list-item-subtitle
                                                  >
                                             </v-list-item-content>
                                             <v-list-item-action>
                                                  <v-list-item-action-text
                                                       class="font-weight-bold"
                                                       style="font-size: 1.75em"
                                                  >
                                                       ${{
                                                            subItem.price
                                                       }}</v-list-item-action-text
                                                  >
                                             </v-list-item-action>
                                        </v-list-item>
                                        <!-- 
 Lorem ipsum dolor sit amet, consectetur
                                        adipiscing elit, sed do eiusmod tempor
                                        incididunt ut labore et dolore magna
                                        aliqua. Ut enim ad minim veniam, quis
                                        nostrud exercitation ullamco laboris
                                        nisi ut aliquip ex ea commodo consequat.

                                        -->
                                   </v-col>
                              </v-row>
                         </v-expansion-panel-content>
                    </v-expansion-panel>
               </v-expansion-panels>
          </v-row>
          <!--<v-card class="mx-auto elevation-5" color="white">
               <v-row no-gutters>
                    <v-card-text>
                         <v-col cols="12" md="12" sm="12">
                              <v-list>
                                   <template v-for="(item, index) in list">
                                        <v-list-item :key="index">
                                             <v-list-item-content>
                                                  <v-list-item-title
                                                       class="primary--text"
                                                       style="font-size: 1.5em"
                                                       v-html="item.name"
                                                  ></v-list-item-title>
                                                  <v-list-item-subtitle
                                                       style="font-size: 1em"
                                                       class="text-wrap"
                                                       v-html="item.description"
                                                  ></v-list-item-subtitle>
                                             </v-list-item-content>
                                             <v-list-item-action>
                                                  <v-list-item-action-text
                                                       v-text="item.price"
                                                       class="font-weight-bold"
                                                       style="font-size: 2em"
                                                  ></v-list-item-action-text>
                                             </v-list-item-action>
                                        </v-list-item>
                                        <v-divider :key="index"></v-divider>
                                   </template>
                              </v-list>
                         </v-col>
                    </v-card-text>
               </v-row>
          </v-card>
          -->
     </v-theme-provider>
</template>

<script>
export default {
     name: 'BaseFoodMenu',
     props: {
          dark: Boolean,
          list: Array,
          color: {
               type: String,
               default: 'primary',
          },
     },
     data: () => ({}),
}
</script>
